import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}

export const getBuscarDocumento = async (oid: number): Promise<boolean> => {
  try {
    const res = await apiClient.post<ApiResponse<boolean>>(
      Endpoints.PagoBuscarDocumento,
      {
        oidLiquidacion: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
